import { render } from "./HeroSideBar.vue?vue&type=template&id=54cfaea0"
import script from "./HeroSideBar.vue?vue&type=script&lang=js"
export * from "./HeroSideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__